/** @jsx jsx */

import { jsx, render, SelectionSet, Field, Variable, Mutation } from "graphql-jsx";
import { clients } from "utils/clients";
import { UuidScalar } from "GraphQL/Scalars";

type Option = Readonly<{
  id: string;
}>;

export const DeleteTrackLicense = async (option: Option) => {
  const $uuid = <Variable name="id" scalar={<UuidScalar />} value={option.id} />;
  const { query, variables } = render(
    <Mutation operationName="DELETE_TRACK_LICENSE">
      <SelectionSet
        name="deleteTrack_license"
        alias="deleteTrackLicense"
        argument={{
          where: {
            id: $uuid
          }
        }}
      >
        <Field name="id" />
      </SelectionSet>
    </Mutation>
  );
  type Data = Readonly<{
    deleteTrackLicense: Readonly<{
      id: string;
    }>[];
  }>;
  return await clients.metadata.request<Data>(query, variables);
};
